import React from 'react';
import { Pof } from '../../../store/pof/Pof';
import { EnumStatus } from '../../../utils/EnumHelpers';

export const PofStatus = EnumStatus(Pof.status);
